module.exports = __webpack_public_path__ + "static/burdock_board_medium.0ffd2dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/boards/burdock_board_medium.jpg
// module id = 629
// module chunks = 216635586879231